import type { ReactNode } from 'react';
import { Box, type BoxProps } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { detailPageContentSx, fullBleedPageContentSx, listPageContentSx } from '@/common/presentation/constants/pageLayout';

export type PageContainerVariant = 'list' | 'detail' | 'full-bleed';

interface PageContainerProps extends Omit<BoxProps, 'children' | 'sx'> {
  children: ReactNode;
  sx?: SxProps<Theme>;
  variant?: PageContainerVariant;
}

const VARIANT_SX: Record<PageContainerVariant, SxProps<Theme>> = {
  list: listPageContentSx,
  detail: detailPageContentSx,
  'full-bleed': fullBleedPageContentSx
};

export function PageContainer({ children, sx, variant = 'list', ...boxProps }: PageContainerProps) {
  const baseSx = VARIANT_SX[variant];
  const mergedSx = (sx ? [baseSx, sx] : baseSx) as unknown as SxProps<Theme>;

  return (
    <Box {...boxProps} sx={mergedSx}>
      {children}
    </Box>
  );
}
